import { LOADING_TAGS, RECEIVE_TAGS } from './actions';

const initialState = {
  list: [],
  isLoading: false,
};

export default function tags(state = initialState, action) {
  switch (action.type) {
    case LOADING_TAGS:
      return {
        ...state,
        isLoading: true,
      };
    case RECEIVE_TAGS:
      return {
        ...state,
        isLoading: false,
        list: action.tags,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/tags/reducer.js